export default class Footer {
  constructor() {
    this.$this = $('footer.footer')
    this.$openChildMenu = this.$this.find('.open-child-menu')

    this.classes = {
      subMenuFooter: '.sub-menu-footer',
      footer: 'footer.footer',
      openChildMenu: '.open-child-menu',
    }
  }

  init() {
    $('body').on('click', this.classes.openChildMenu, (e) => {
      const $target = $(e.currentTarget)
      const $parent = $target.closest('li.has-sub')
      const $menuParent = $target.closest('ul.sub-menu-footer')
      $menuParent.find(this.classes.openChildMenu).not($target).removeClass('active')
      $menuParent.find(this.classes.subMenuFooter).not($parent.find(this.classes.subMenuFooter)).slideUp()
      if ($target.hasClass('active')) {
        $target.removeClass('active')
        $parent.find(this.classes.subMenuFooter).slideUp()
      } else {
        $target.addClass('active')
        $parent.find(this.classes.subMenuFooter).slideDown()
      }
    })
  }
}

new Footer().init()
